import { ReactEasyForm, Select } from "@aeco-cloud/react-easy-form";
import { useTheme } from "@material-ui/core";
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextContext } from "../../../pages/bepaal-statuut";
import { Label, NavigationButtons, Question, Section } from "../../form-layout";
import StepBody from "../../form-layout/StepBody";
import Markdown from "../../Markdown";
import { SendContext } from "../BepaalStatuut";

const Quarter = () => {
  const text = useContext(TextContext);
  const send = useContext(SendContext);
  const form = useForm();
  const theme = useTheme();

  const onSubmit: SubmitHandler<any> = (data) => {
    console.log(data);
    send({ type: "NEXT", data: data });
  };

  const onBack = () => {
    send({ type: "BACK" });
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  let currentQuarter = "1";
  if ([1, 2, 3].includes(currentMonth)) {
    currentQuarter = "1";
  } else if ([4, 5, 6].includes(currentMonth)) {
    currentQuarter = "2";
  } else if ([7, 8, 9].includes(currentMonth)) {
    currentQuarter = "3";
  } else {
    currentQuarter = "4";
  }

  const determineYearsOptions = (currentYear: number, currentQuarter: string) => {
    let yearsArray = [currentYear - 2, currentYear - 1, currentYear];

    if (currentQuarter === "4") {
      yearsArray = [currentYear - 2, currentYear - 1, currentYear, currentYear + 1];
    }
    const yearsOptions = yearsArray.map((year) => {
      return { value: year.toString(), label: year.toString() };
    });

    return yearsOptions;
  };

  const determineQuarterOptions = (
    selectedYear: number,
    currentYear: number,
    currentQuarter: string
  ) => {
    let quarterOptions = [
      { value: "1", label: text.quarter_quarter1 },
      { value: "2", label: text.quarter_quarter2 },
      { value: "3", label: text.quarter_quarter3 },
      { value: "4", label: text.quarter_quarter4 },
    ];

    if (currentYear === selectedYear) {
      if (currentQuarter === "1") {
        quarterOptions = quarterOptions.slice(0, 2);
      } else if (currentQuarter === "2") {
        quarterOptions = quarterOptions.slice(0, 3);
      } else if (currentQuarter === "3") {
        quarterOptions = quarterOptions.slice(0, 4);
      } else if (currentQuarter === "4") {
        quarterOptions = quarterOptions.slice(0, 4);
      }
    } else if (selectedYear === currentYear + 1 && currentQuarter === "4") {
      quarterOptions = quarterOptions.slice(0, 1);
    }

    return quarterOptions;
  };

  return (
    <ReactEasyForm form={form}>
      <StepBody>
        <Section>
          <Question>
            <Label label={text.quarter_period} />
            <div
              style={{
                display: "grid",
                gridTemplateColumns: `repeat(auto-fit, minmax(240px,1fr))`,
              }}
            >
              <Select
                name="quarterYear"
                options={determineYearsOptions(currentYear, currentQuarter)}
                muiSelectProps={{ fullWidth: true, variant: "outlined" }}
                defaultValue={currentYear.toString()}
                rules={{
                  required: text.general_requiredQuestion,
                }}
              />
              <Select
                name="quarterNumber"
                defaultValue={currentQuarter}
                options={determineQuarterOptions(
                  parseInt(form.watch("quarterYear")),
                  currentYear,
                  currentQuarter
                )}
                rules={{ required: text.general_requiredQuestion }}
                muiSelectProps={{ fullWidth: true, variant: "outlined" }}
              />
            </div>
          </Question>
        </Section>
        <div
          style={{
            textAlign: "center",
            width: "100%",
            display:
              form.watch("quarterNumber") === currentQuarter &&
              form.watch("quarterYear") === currentYear.toString()
                ? "none"
                : "block",
          }}
        >
          <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <ErrorOutlineOutlinedIcon htmlColor={theme.palette.primary.light} fontSize="small" style={{marginRight:theme.spacing(2)}}/>
            <Markdown>{text.quarter_perspective}</Markdown>
          </div>
        </div>
      </StepBody>
      {/* <Label>Voor welk jaar wil je simuleren?</Label> */}
      <NavigationButtons onBack={onBack} onNext={form.handleSubmit(onSubmit)} />
    </ReactEasyForm>
  );
};
export default Quarter;
